// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/weather_forecast_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { AreaWeatherForecast } from "./weather_forecast_model_pb";
import { file_bffuser_v1_weather_forecast_model } from "./weather_forecast_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/weather_forecast_service.proto.
 */
export const file_bffuser_v1_weather_forecast_service: GenFile = /*@__PURE__*/
  fileDesc("CiliZmZ1c2VyL3YxL3dlYXRoZXJfZm9yZWNhc3Rfc2VydmljZS5wcm90bxIKYmZmdXNlci52MSK9AQodR2V0QXJlYVdlYXRoZXJGb3JlY2FzdFJlcXVlc3QSNAoJYXJlYV9jb2RlGAEgASgOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGVCCrpIB4IBBBABIAASMwoQdGFyZ2V0X2RhdGVfZnJvbRgCIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVCBrpIA8gBARIxCg50YXJnZXRfZGF0ZV90bxgDIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVCBrpIA8gBASJTCh5HZXRBcmVhV2VhdGhlckZvcmVjYXN0UmVzcG9uc2USMQoIZm9yZWNhc3QYASABKAsyHy5iZmZ1c2VyLnYxLkFyZWFXZWF0aGVyRm9yZWNhc3QyiwEKFldlYXRoZXJGb3JlY2FzdFNlcnZpY2UScQoWR2V0QXJlYVdlYXRoZXJGb3JlY2FzdBIpLmJmZnVzZXIudjEuR2V0QXJlYVdlYXRoZXJGb3JlY2FzdFJlcXVlc3QaKi5iZmZ1c2VyLnYxLkdldEFyZWFXZWF0aGVyRm9yZWNhc3RSZXNwb25zZSIAQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bfftypes_v1_area, file_bffuser_v1_weather_forecast_model, file_buf_validate_validate, file_google_type_date]);

/**
 * GetAreaWeatherForecastRequest carries the area and inclusive target-date
 * range.
 *
 * @generated from message bffuser.v1.GetAreaWeatherForecastRequest
 */
export type GetAreaWeatherForecastRequest = Message<"bffuser.v1.GetAreaWeatherForecastRequest"> & {
  /**
   * Target electricity area. UNSPECIFIED is rejected.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * Inclusive start of the target-date range.
   *
   * @generated from field: google.type.Date target_date_from = 2;
   */
  targetDateFrom?: Date;

  /**
   * Inclusive end of the target-date range. Must be >= target_date_from.
   *
   * @generated from field: google.type.Date target_date_to = 3;
   */
  targetDateTo?: Date;
};

/**
 * Describes the message bffuser.v1.GetAreaWeatherForecastRequest.
 * Use `create(GetAreaWeatherForecastRequestSchema)` to create a new message.
 */
export const GetAreaWeatherForecastRequestSchema: GenMessage<GetAreaWeatherForecastRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_service, 0);

/**
 * @generated from message bffuser.v1.GetAreaWeatherForecastResponse
 */
export type GetAreaWeatherForecastResponse = Message<"bffuser.v1.GetAreaWeatherForecastResponse"> & {
  /**
   * @generated from field: bffuser.v1.AreaWeatherForecast forecast = 1;
   */
  forecast?: AreaWeatherForecast;
};

/**
 * Describes the message bffuser.v1.GetAreaWeatherForecastResponse.
 * Use `create(GetAreaWeatherForecastResponseSchema)` to create a new message.
 */
export const GetAreaWeatherForecastResponseSchema: GenMessage<GetAreaWeatherForecastResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_weather_forecast_service, 1);

/**
 * WeatherForecastService provides live JMA weather forecasts (sourced from
 * BigQuery) for the generation/consumption planning screens.
 *
 * @generated from service bffuser.v1.WeatherForecastService
 */
export const WeatherForecastService: GenService<{
  /**
   * GetAreaWeatherForecast returns the 8-metric forecast bundle for the area
   * and target-date range. organization_id is resolved by the BFF handler
   * from eauth.
   *
   * @generated from rpc bffuser.v1.WeatherForecastService.GetAreaWeatherForecast
   */
  getAreaWeatherForecast: {
    methodKind: "unary";
    input: typeof GetAreaWeatherForecastRequestSchema;
    output: typeof GetAreaWeatherForecastResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_weather_forecast_service, 0);

